import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

interface MetricCardProps {
  eyebrow: string;
  value: string;
  note?: string;
  icon?: React.ReactNode;
  accent?: string;
}

export default function MetricCard({ eyebrow, value, note, icon, accent = "#c08b57" }: MetricCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        position: "relative",
        overflow: "hidden",
        minHeight: 156,
        p: 2.5,
        borderRadius: 3,
        border: "1px solid rgba(118, 93, 68, 0.12)",
        background:
          "linear-gradient(145deg, rgba(255, 252, 247, 0.98) 0%, rgba(248, 239, 229, 0.94) 100%)",
        boxShadow: "0 18px 42px rgba(105, 77, 49, 0.1)",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: "0 auto 0 0",
          width: 5,
          background: accent
        },
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.28) 0%, transparent 42%), repeating-linear-gradient(135deg, rgba(138,90,60,0.045) 0 1px, transparent 1px 14px)",
          opacity: 0.65,
          pointerEvents: "none"
        }
      }}
    >
      <Stack spacing={1.25} sx={{ position: "relative", zIndex: 1, minWidth: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1.5}>
          <Typography variant="caption" sx={{ color: "#8b6b4f", textTransform: "uppercase", letterSpacing: "0.18em", fontWeight: 800 }}>
            {eyebrow}
          </Typography>
          {icon ? (
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "50%",
                display: "grid",
                placeItems: "center",
                color: "#fffaf4",
                background: accent,
                boxShadow: "0 10px 20px rgba(95, 60, 38, 0.16)"
              }}
            >
              {icon}
            </Box>
          ) : null}
        </Stack>
        <Typography variant="h4" sx={{ fontWeight: 900, color: "#2f2118", fontSize: { xs: "1.55rem", md: "1.8rem", xl: "2rem" }, overflowWrap: "anywhere" }}>
          {value}
        </Typography>
        {note ? <Typography variant="body2" sx={{ color: "#7b6857" }}>{note}</Typography> : null}
      </Stack>
    </Paper>
  );
}
